export enum TournamentState {
  Open = 'OPEN',
  Planable = 'PLANABLE',
  Playable = 'PLAYABLE',
  Closed = 'CLOSED',
}
